import './SanityHeader.scss';
import { SanityHeaderProps } from './SanityHeader.types';

function SanityHeader({ title, author, date }: SanityHeaderProps) {
  return (
    <div className="sanity-header">
      <div className="sanity-header-title">{title}</div>
      {/*<div className="blog-info d-none d-sm-flex"> //REMOVED FOR MVP
        Posted by <div className="author"> {author || 'URBAIN'} </div> | {moment(date).format('MMM DD, YYYY')}
      </div>*/}
    </div>
  );
}
export default SanityHeader;
